import { render } from "./CadastrosGeraisSubGrupos.vue?vue&type=template&id=534dcb45"
import script from "./CadastrosGeraisSubGrupos.vue?vue&type=script&lang=js"
export * from "./CadastrosGeraisSubGrupos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__